const CHANGE_PASSWORD_REQUIRED_FIELDS = ["newPassword", "confirmNewPassword"]

export const RequiredFields = {
  CHANGE_PASSWORD_REQUIRED_FIELDS,
}
